import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-date-range-modal',
    templateUrl: './date-range-modal.component.html',
    styleUrl: './date-range-modal.component.scss',
    standalone: false
})
export class DateRangeModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  
  @Input() range!: (string | number | Date)[];
  @Output() rangeChange = new EventEmitter<(string | number | Date)[] | null>();

  @Input() minDate?: Date;
  @Input() maxDate?: Date;

  apply(): void {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
    this.rangeChange.emit(this.range);
  }

  onPopupClosed(): void {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);

    if (!this.range[0] || !this.range[1]) {
      this.rangeChange.emit(null);
    }
  }
}
